module.exports = __webpack_public_path__ + "img/prime minister_homepage.78bce5ab.png";